import * as angular from "angular";
import * as _ from "lodash";
import {SitesRequestsService} from "./modules/sites/services/sites-requests.service";
import {$accountFactory} from "./modules/account/$account.factory";
import {SyncService} from "./modules/persistence-layer/sync-service.service";
import {IHttpService, IQService} from "angular";
import {OrganizationsRequestsService} from "./modules/organizations/services/organizations-requests.factory";
import {SiteContextService} from "./modules/commons/services/site-context.service";
import {ApiConfig} from "./modules/commons/models/api-config.model";
import {OmsOrdersNotificationsService} from "./modules/commons/services/oms-orders-notifications.service";
import {SplitService} from "./modules/commons/services/split-service.service";
import {FirebaseService} from "./modules/persistence-layer/firebase.service";
import {ViewSettingsService} from "./modules/commons/services/view-settings-service.service";
import {
  ViewSettingsModel,
  ViewSettingsType
} from "./modules/commons/models/view-settings.model";

angular
  .module('app')
  .config(routeConfig);

/* @ngInject */
function routeConfig($stateProvider, $urlRouterProvider) {

  $stateProvider

    // Main State
    .state('bringoz', {
      abstract: true,
      views: {
        'root': {
          template: '<root-component maps="vm.maps"></root-component>',
          controllerAs: 'vm',
          controller: function (maps) {
            this.maps = maps;
          }
        },
        'sidebarRight@bringoz': {
          template: '<right-side-nav></right-side-nav>'
        }
      },
      resolve: {
        // help : (BringozHelpApi) => {
        //     return BringozHelpApi;
        // },

        // userInterceptor: ($q: IQService, UserService, $state, Heap) => {
        //   const deferred = $q.defer();
        //   const currentUser = UserService.getCurrentUser();
        //
        //   if (currentUser) {
        //     Heap.identify(currentUser.id);
        //     deferred.resolve(currentUser);
        //   } else {
        //     deferred.reject('Not logged in');
        //     $state.go('authentication.login');
        //   }
        //   return deferred.promise;
        // },

        tokenInterceptor: ($q: IQService, UserService, $state, Heap) => {
          const deferred = $q.defer();
          const token: string = localStorage.getItem('admin_token') || localStorage.getItem('access_token');

          if (!token) {
            deferred.reject('Not logged in');
            $state.go('authentication.login');
          } else {
            deferred.resolve(token);
          }

          return deferred.promise;
        },
        user: ($q: IQService, UserService, tokenInterceptor, Heap) => {
          const deferred = $q.defer();

          const refreshUser = () => UserService.getUser()
            .then((data) => {
              Heap.identify(data.user?.id);
              return data.user;
            });

          const cachedUser = UserService.getCurrentUser();

          if (cachedUser) {
            // Already have a cached user from a previous session - don't block on a
            // fresh fetch, just refresh it in the background.
            deferred.resolve(cachedUser);
            refreshUser().catch(() => {});
          } else {
            refreshUser()
              .then((user) => {
                deferred.resolve(user);
              })
              .catch(() => {
                deferred.reject('No user found');
              });
          }

          return deferred.promise;
        },
        maps: (uiGmapGoogleMapApi) => {
          return uiGmapGoogleMapApi;
        },
        intercomUpdate: (intercom) => {
          intercom.toggleShowDefaultLauncher(false);
        }
      }
    })
    .state('bringoz.super', {
      abstract: true,
      views: {
        'main@bringoz': {
          template: '<welcome-main-view></welcome-main-view>'
        }
      },
      resolve: {
        // _flavor: (templates, tokenInterceptor) => {
        //   return templates.resetSiteFlavor();
        // },
        // _permissions: (IAMPermissions, $timeout, tokenInterceptor) => {
        //   return IAMPermissions.setSuperPermissions();
        // },
        _firebase: (syncService: SyncService, siteContextService: SiteContextService, tokenInterceptor) => {
          siteContextService.resetSite(); //Sync
          return syncService.destroyFirebase();
        },
        // _firebaseApp: (_firebase, firebaseAppService: FirebaseAppService) => {
        //   return firebaseAppService.destroyFirebase();
        // },
        _notifications: (omsOrdersNotificationsService: OmsOrdersNotificationsService) => {
          omsOrdersNotificationsService.destroyOmsOrdersNotifications();
          return;
        }
        // _async: (currentUser, BringozHelp, analyticsService, _permissions, help) => {
        //     BringozHelp.setContext(currentUser, _permissions);
        //     analyticsService.initWelcome(currentUser, _permissions);
        // }
        // _async: (UserService, intercom, analyticsService: AnalyticsService, _permissions, tokenInterceptor) => {
        //   const user = UserService.getCurrentUser();
        //   intercom.update(user, 'Welcome Page', _permissions);
        //   analyticsService.initWelcome(user, _permissions);
        // }
      }
    })
    .state('bringoz.org', {
      url: '?:orgId',
      abstract: true,
      views: {
        'main@bringoz': {
          template: '<organization-main-view organization="vm.organization"></organization-main-view>',
          controllerAs: 'vm',
          controller: function (organization) {
            this.organization = organization;
          }
        }
      },
      resolve: {
        orgId: ($stateParams) => {
          return $stateParams.orgId;
        },
        // _flavor: (templates) => {
        //   return templates.resetSiteFlavor();
        // },
        // _permissions: (orgId, IAMPermissions) => {
        //   return IAMPermissions.setOrganizationPermissions(orgId);
        // },
        _firebase: (syncService: SyncService, siteContextService: SiteContextService) => {
          siteContextService.resetSite(); //Sync
          return syncService.destroyFirebase();
        },
        // _firebaseApp: (_firebase, firebaseAppService: FirebaseAppService) => {
        //   return firebaseAppService.destroyFirebase();
        // },
        _notifications: (omsOrdersNotificationsService: OmsOrdersNotificationsService) => {
          omsOrdersNotificationsService.destroyOmsOrdersNotifications();
          return;
        },
        organization: (orgId, organizationsRequestsService: OrganizationsRequestsService) => {
          return organizationsRequestsService.getOrganization(orgId);
        }
        // _async: (currentUser, BringozHelp, analyticsService, organization, _permissions, help) => {
        //     BringozHelp.setContext(currentUser, _permissions, organization);
        //     analyticsService.initOrganization(currentUser, organization, _permissions);
        // }
        // _async: (UserService, intercom, analyticsService: AnalyticsService, organization, _permissions) => {
        //   const user = UserService.getCurrentUser();
        //   const organizationName = 'Organization - ' + organization.name;
        //   intercom.update(user, organizationName, _permissions,
        //     organization);
        //   analyticsService.initOrganization(user, organization,
        //     _permissions);
        // }
      }
    })
    .state('bringoz.site', {
      url: '?:siteId',
      params: {
        state: null
      },
      abstract: true,
      views: {
        'main@bringoz': {
          template: '<site-main-view site="vm.site" default-home-page-settings="vm.defaultHomePageSettings"></site-main-view>',
          controllerAs: 'vm',
          controller: function (site, $stateParams, siteViewSettings, viewSettingsService: ViewSettingsService, $state, siteId) {
            this.site = site;

            const userDefaultHomePageSettings = viewSettingsService.getUserDefaultHomePage;
            const siteDefaultHomePageSettings = viewSettingsService.getSiteDefaultHomePage;

            this.defaultHomePageSettings = !!userDefaultHomePageSettings ? userDefaultHomePageSettings : siteDefaultHomePageSettings;
          }
        }
      },
      resolve: {
        // siteId: ($stateParams, tokenInterceptor, siteContextService, $q) => {
        //   siteContextService.resetSite(); //Sync
        //   const deferred = $q.defer();
        //
        //   // maybe use this.$window.localStorage?
        //   // sometimes after cleanup (siteContextService.resetSite) the site id still null
        //
        //   if (!$stateParams.siteId && $stateParams.state) { //Workaround for OAuth 2 flow
        //     const decodedURI = decodeURIComponent($stateParams.state).split('_')[0];
        //     if (!!decodedURI) {
        //       localStorage.setItem("currentSiteId", decodedURI);
        //       deferred.resolve(decodedURI);
        //     } else {
        //       deferred.reject('No Site ID');
        //     }
        //   } else {
        //     if (!$stateParams.siteId) {
        //       deferred.reject('No Site ID');
        //     } else {
        //       localStorage.setItem("currentSiteId", $stateParams.siteId);
        //       deferred.resolve($stateParams.siteId);
        //     }
        //   }
        //
        //   return deferred.promise;
        // },
        siteId: ($stateParams, siteContextService, $window) => {
          siteContextService.resetSite(); // Synchronous cleanup

          let siteId = null;

          // Workaround for OAuth2: extract from `state` if `siteId` is missing
          if (!$stateParams.siteId && $stateParams.state) {
            const decodedURI = decodeURIComponent($stateParams.state).split('_')[0];
            if (decodedURI) {
              siteId = decodedURI;
            }
          } else if ($stateParams.siteId) {
            siteId = $stateParams.siteId;
          }

          if (!siteId) {
            throw new Error('No Site ID');
          }

          try {
            $window.sessionStorage.setItem("currentSiteId", siteId);
          } catch (e) {
            console.warn("Could not write to sessionStorage", e);
          }

          return siteId; // treats this as a resolved value
        },
        // _firebaseApp: (accountsChanelService: AccountsChanelService, siteId: string) => {
        //   return lastValueFrom(accountsChanelService.initFirebase(siteId));
        // },
        _firebase: (syncService: SyncService, firebaseService: FirebaseService, siteId, siteContextService: SiteContextService) => {
          return syncService.destroyFirebase()
            .then(() => {
              return firebaseService.initFirebase(siteId);
            });
        },
        // _firebaseApp: (_firebase, firebaseAppService: FirebaseAppService, site) => {
        //   return firebaseAppService.initFirebase(site.id);
        // },
        // site: (siteId, sitesRequestsService: SitesRequestsService) => {
        //     return sitesRequestsService.getSite(siteId);
        // },
        site: ($q, siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService, $translatePartialLoader, $translate) => {
          // bringozLoaderService.on();
          const deferred = $q.defer();
          sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);

              const languageFlavor = siteInfo.languageFlavor || 'default';

              // Clean all overrides except the core
              const registeredParts = _.drop($translatePartialLoader.getRegisteredParts());
              _.forEach(registeredParts, (part) => {
                $translatePartialLoader.deletePart(part, false);
              });

              if (languageFlavor !== 'default') {
                $translatePartialLoader.addPart(languageFlavor, 1);
              }
              $translate.refresh();

              deferred.resolve({
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              });
            })
            .catch((error) => {
              deferred.reject(error);
            })
            .finally(() => {
              // bringozLoaderService.off();
            })

          return deferred.promise;

          // return sitesRequestsService.getSiteInfo(siteId)
          //   .then((siteInfo) => {
          //     siteContextService.setSiteInfo(siteInfo);
          //
          //     const languageFlavor = siteInfo.languageFlavor || 'default';
          //
          //     // Clean all overrides except the core
          //     const registeredParts = _.drop($translatePartialLoader.getRegisteredParts());
          //     _.forEach(registeredParts, (part) => {
          //       $translatePartialLoader.deletePart(part, false);
          //     });
          //
          //     if (languageFlavor !== 'default') {
          //       $translatePartialLoader.addPart(languageFlavor, 1);
          //     }
          //     $translate.refresh();
          //
          //     return {
          //       id: siteInfo.siteId,
          //       name: siteInfo.siteName,
          //       parent: {
          //         id: siteInfo.organizationId,
          //         name: siteInfo.organizationName,
          //       }
          //     };
          //   })
          //   .finally(() => {
          //     bringozLoaderService.off();
          //   })
        },
        _notifications: (omsOrdersNotificationsService: OmsOrdersNotificationsService, siteContextService: SiteContextService, splitService: SplitService, site) => {
          if (siteContextService.getSiteInfo().showNewOrderNotifications && splitService.getIsNewOrderNotificationsEnabled()) {
            omsOrdersNotificationsService.initOrdersChannelNotifications();
          }
          return;
        },
        // defaultHomePageSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
        //   return viewSettingsService.get(undefined, ViewSettingsType.HomePage);
        // },
        siteViewSettings: function (viewSettingsService: ViewSettingsService, $state, $q, site) {
          const deferred = $q.defer();

          viewSettingsService.get(undefined, [ViewSettingsType.HomePage, ViewSettingsType.GeneralSettings])
            .then((viewSettings: ViewSettingsModel[]) => {

              viewSettingsService.setSiteSettings(viewSettings);
              deferred.resolve(viewSettings);
            })

          return deferred.promise;
        }
        // plan: (siteId, sitesRequestsService: SitesRequestsService) => {
        //   return sitesRequestsService.getSitePlan(siteId);
        // },

        // _flavor: (templates, plan, siteId) => {
        //   return templates.setSiteFlavor(plan.flavor);
        // },
        // _permissions: (siteId, IAMPermissions, siteContextService: SiteContextService, site) => {
        //   const siteInfo = siteContextService.getSiteInfo();
        //   return IAMPermissions.setSitePermissions(siteId, siteInfo.sitePlan.modules);
        // },
        // metadataSettings: (deliveriesService: DeliveriesService, site) => {
        //   return DeliveriesService.getDeliveryMetadataSettings();
        // },
        // suspend: (site, _permissions, siteContextService: SiteContextService, CommonsDialogService) => {
        //    const siteInfo = siteContextService.getSiteInfo();
        //    if (_.get(siteInfo, 'suspended')) {
        //       CommonsDialogService.suspendSite()
        //           .then(() => {
        //
        //           })
        //    }
        //    return true;
        // },
        // _async: (currentUser, BringozHelp, analyticsService, site, _permissions, help) => {
        //     BringozHelp.setContext(currentUser, _permissions, site.parent, site);
        //     analyticsService.initSite(currentUser, site, _permissions);
        // }
        // _async: (UserService, intercom, analyticsService: AnalyticsService, site, _permissions) => {
        //   const user = UserService.getCurrentUser();
        //   intercom.update(user, site.name, _permissions, site.parent);
        //   analyticsService.initSite(user, site, _permissions);
        // }
      }
    })
    .state('welcome', {
      url: '/welcome',
      parent: 'bringoz.site',
      // controller: (state, $state) => {
      //   $state.go(state);
      // },
      // resolve: {
      //   state: (_permissions) => {
      //     const posRole = _.find(_permissions, (role) => {
      //       // return role.id === 'site.pos';
      //       return role ? role.id === 'site.pos' : undefined;
      //     });
      //
      //     return posRole && _permissions.length < 2 ?
      //       'point-of-sale.create-delivery' : 'deliveries.table'
      //   }
      // }
    })

    // Printing State
    .state('print', {
      url: '/print',
      abstract: true,
      views: {
        'root': {
          template: '<ui-view class="full-width"></ui-view>',
        },
      },
    })

    // Printing State - Order bill of lading
    .state('print.order-bil-of-lading', {
      url: '/order-bil-of-lading/orders?:orderIds&:siteId',
      params: {
        siteId: null,
        orderIds: null
      },
      template: '<order-print-bill-of-lading orders="vm.orders" billing-account="vm.billingAccount" class="full-width"></order-print-bill-of-lading>',
      controllerAs: 'vm',
      controller: function ($stateParams, orders, billingAccount) {
        this.orders = orders;
        this.billingAccount = billingAccount;
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        orders: (site, siteId, $stateParams, $omsOrder) => {
          return $omsOrder().$asyncValues($stateParams.orderIds);
        },
        account: (site, siteId, orders, $account: $accountFactory) => {
          return $account(orders[0].accountId).$asyncValue();
        },
        billingAccount: function ($billingAccounts, account, $q) {
          return account.billingAccountId ?
            $billingAccounts(account.billingAccountId).$instantGet() :
            $q.when();
        }
      }
    })

    // Printing State - Service
    .state('print.services', {
      url: '/services?:servicesIds&:siteId&:printTaskPurpose',
      params: {
        siteId: null,
        servicesIds: null,
        printTaskPurpose: null
      },
      template: '<services-print-page services="vm.services" print-task-purpose="vm.printTaskPurpose" class="full-width"></services-print-page>',
      controllerAs: 'vm',
      controller: function ($stateParams, services) {
        this.services = _.get(services, 'data.list');
        this.printTaskPurpose = $stateParams.printTaskPurpose;
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        services: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const url = apiConfig.baseUrl + `/services`;
          return $http.get(url, {
            params: {
              siteId: siteId,
              ids: $stateParams.servicesIds
            }
          })
        }
      }
    })

    // Printing State - Itinerary
    .state('print.itinerary', {
      url: '/itinerary/:agentId?:siteId',
      params: {
        agentId: null,
        siteId: null
      },
      template: '<agent-itinerary-print-page agent="vm.agent" itinerary="vm.itinerary" tasks="vm.tasks" class="full-width"></agent-itinerary-print-page>',
      controllerAs: 'vm',
      controller: function (agent, itinerary) {
        this.agent = agent.data;
        this.itinerary = itinerary.data;
        this.tasks = this.itinerary.taskListExt;
        // this.tasks = tasks.data.list;
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        agent: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const url = apiConfig.baseUrl + `/agents/` + $stateParams.agentId;
          return $http.get(url, {
            params: {
              siteId: siteId
            }
          })
        },
        itinerary: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const url = apiConfig.baseUrl + `/agents/` + $stateParams.agentId + '/itinerary';
          return $http.get(url, {
            params: {
              siteId: siteId
            }
          })
        }
      }
    })

    // Printing State - Packages
    .state('print.packages', {
      url: '/packages/:agentId?:siteId',
      params: {
        agentId: null,
        siteId: null
      },
      template: '<agent-packages-print-page agent="vm.agent" tasks="vm.tasks" class="full-width"></agent-packages-print-page>',
      controllerAs: 'vm',
      controller: function (agent, itinerary, tasks) {
        this.agent = agent.data;
        this.tasks = tasks.data.list;
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        agent: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const url = apiConfig.baseUrl + `/agents/` + $stateParams.agentId;
          return $http.get(url, {
            params: {
              siteId: siteId
            }
          })
        },
        itinerary: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const url = apiConfig.baseUrl + `/agents/` + $stateParams.agentId
            + '/itinerary';
          return $http.get(url, {
            params: {
              siteId: siteId
            }
          })
        },
        tasks: (siteId, itinerary, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const taskIds = _.get(itinerary, 'data.taskIdListExt');
          const url = apiConfig.baseUrl + `/tasks/`;
          return $http.get(url, {
            params: {
              siteId: siteId,
              ids: taskIds
            }
          })
        }
      }
    })

    // Printing - route
    .state('print.routes', {
      url: '/routes?:routeIds&:syncIds&:siteId',
      params: {
        routeIds: null,
        syncIds: null,
        siteId: null
      },
      template: '<lean-planning-routes-print-page routes="vm.routes" service-areas="vm.serviceAreas" class="full-width"></lean-planning-routes-print-page>',
      controllerAs: 'vm',
      controller: function (routes, serviceAreas, site) {
        this.routes = _.get(routes, 'data.list') || _.get(routes, 'data', []);
        this.serviceAreas = _.get(serviceAreas, 'data', []);
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        routes: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const routeIds = $stateParams.routeIds;
          const syncIds = $stateParams.syncIds;

          function parseArrayStateParam(val) {
            if (!val) {
              return;
            }
            return _.isArray(val) ? val : [val]
          }

          if (syncIds) {
            const url = apiConfig.baseUrl + `/routes/syncIds`;
            return $http.get(url, {
              params: {
                siteId: siteId,
                syncIds: parseArrayStateParam(syncIds),
                expand: true
              }
            })
          } else {
            const url = apiConfig.baseUrl + `/leanPlanning/routes`;
            return $http.get(url, {
              params: {
                siteId: siteId,
                ids: parseArrayStateParam(routeIds),
                expanded: true
              }
            })
          }
        },
        serviceAreas: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService, routes, $q) => {
          const serviceAreaIds = _.uniq(_.flatMap(_.get(routes.data, 'list', []), 'serviceAreaIdList'));
          const url = apiConfig.baseUrl + `/areas`;

          if (!serviceAreaIds.length) {
            return $q.when([]);
          } else {
            return $http.get(url, {
              params: {
                siteId: siteId,
                ids: serviceAreaIds
              }
            })
          }
        }
      }
    })

    // Printing - vouchers
    .state('print.vouchers', {
      url: '/vouchers?:ids&:siteId',
      params: {
        ids: null,
        siteId: null
      },
      template: '<app-vouchers-print-page [voucher]="vm.voucher" class="full-width"></app-vouchers-print-page>',
      controllerAs: 'vm',
      controller: function (vouchers, site) {
        const vouchersData = _.get(vouchers, 'data.list') || _.get(vouchers, 'data', []);
        this.voucher = vouchersData.length ? vouchersData[0] : undefined;
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        vouchers: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const ids = parseArrayStateParam($stateParams.ids);

          function parseArrayStateParam(val) {
            if (!val) {
              return;
            }
            return _.isArray(val) ? val : [val]
          }

          const url = apiConfig.baseUrl + `/threepls/train`;
          return $http.get(url, {
            params: {
              siteId: siteId,
              ids: ids
            }
          })
        }
      }
    })

    // Print loading sheet
    .state('print.loading-sheets', {
      url: '/loading-sheets?:routeIds&:syncIds&:siteId',
      params: {
        routeIds: null,
        syncIds: null,
        siteId: null
      },
      template: '<routes-print-loading-sheet routes="vm.routes" class="full-width"></routes-print-loading-sheet>',
      controllerAs: 'vm',
      controller: function (routes) {
        this.routes = _.get(routes, 'data.list') || _.get(routes, 'data', []);
      },
      resolve: {
        siteId: ($stateParams) => {
          return $stateParams.siteId;
        },
        site: (siteId, sitesRequestsService: SitesRequestsService, siteContextService: SiteContextService) => {
          return sitesRequestsService.getSiteInfo(siteId)
            .then((siteInfo) => {
              siteContextService.setSiteInfo(siteInfo);
              return {
                id: siteInfo.siteId,
                name: siteInfo.siteName,
                parent: {
                  id: siteInfo.organizationId,
                  name: siteInfo.organizationName,
                }
              };
            });
        },
        routes: (siteId, apiConfig: ApiConfig, $stateParams, $http: IHttpService) => {
          const routeIds = $stateParams.routeIds;
          const syncIds = $stateParams.syncIds;

          function parseArrayStateParam(val) {
            if (!val) {
              return;
            }
            return _.isArray(val) ? val : [val]
          }

          if (syncIds) {
            const url = apiConfig.baseUrl + `/routes/syncIds`;
            return $http.get(url, {
              params: {
                siteId: siteId,
                syncIds: parseArrayStateParam(syncIds),
                expand: true
              }
            })
          } else {
            const url = apiConfig.baseUrl + `/leanPlanning/routes`;
            return $http.get(url, {
              params: {
                siteId: siteId,
                ids: parseArrayStateParam(routeIds),
                expanded: true
              }
            })
          }

        },
      }
    })

    // Error pages
    .state('404', {
      url: '/404',
      views: {
        'root': {
          template: '<error-page-view template="404"></error-page-view>'
        }
      }
    })
    .state('403', {
      url: '/403',
      views: {
        'root': {
          template: '<error-page-view template="403"></error-page-view>'
        }
      }
    })
    .state('500', {
      url: '/500',
      views: {
        'root': {
          template: '<error-page-view template="500"></error-page-view>'
        }
      }
    })

    .state('sso-login', {
      url: '/token?:code&:state&:session_state',
      views: {
        'root': {
          template: 'Loading...'
        }
      }
    })

    .state('sso-silent-refresh', {
      url: '/silent-refresh?:code&:state&:session_state',
      views: {
        'root': {
          template: '<sso-silent-refresh-view></sso-silent-refresh-view>'
        }
      }
    });

  // set default routes when no path specified
  // $urlRouterProvider.when('', '/organizations/welcome');
  // $urlRouterProvider.when('/', '/organizations/welcome');

  $urlRouterProvider.when('', function ($injector) {
    const $state = $injector.get('$state');

    const token: string = localStorage.getItem('admin_token') || localStorage.getItem('access_token');
    if (!token) {
      $state.go('authentication.login');
    } else {
      $state.go('organizations.overview');
    }
  });

  $urlRouterProvider.when('/', function ($injector) {
    const $state = $injector.get('$state');

    const token: string = localStorage.getItem('admin_token') || localStorage.getItem('access_token');
    if (!token) {
      $state.go('authentication.login');
    } else {
      $state.go('organizations.overview');
    }
  });

  // always goto 404 if route not found
  $urlRouterProvider.otherwise('/404');
}
